module.exports = __webpack_public_path__ + "img/sidebanner_kakaku.2b6afa3b.jpg";